// extracted by mini-css-extract-plugin
module.exports = {"container":"StageOptionList_container__1ejzF","stageWrapper":"StageOptionList_stageWrapper__7Ocxs","stageLabel":"StageOptionList_stageLabel__1xYNU"};